import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ThemePreference = "light" | "dark";

interface ThemeState {
  preference: ThemePreference;
}

function getSystemTheme(): ThemePreference {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

const raw = localStorage.getItem("redux_themePreference");
const initialPref: ThemePreference = raw === "light" || raw === "dark" ? raw : getSystemTheme();

const initialState: ThemeState = { preference: initialPref };

const themeSlice = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setThemePreference(state, action: PayloadAction<ThemePreference>) {
      state.preference = action.payload;
      localStorage.setItem("redux_themePreference", action.payload);
    }
  }
});

export const { setThemePreference } = themeSlice.actions;
export default themeSlice.reducer;
